<app-page-header>
  <div class="header-content">
    <h3 class="page-title">Manage Companies</h3>
  </div>
</app-page-header>

<section class="user-section">
  <div class="container-fluid">

    <!-- =====================================================
         TOP ACTION BAR
    ====================================================== -->
    <div class="top-actions">

      <!-- Search -->
      <div class="search-box">
        <i class="pi pi-search search-icon"></i>

        <input
          type="text"
          [(ngModel)]="search"
          (keyup)="searchInList.next($event)"
          placeholder="Search company..."
          aria-label="Search company"
        />

        @if (search) {
          <button
            type="button"
            class="search-clear"
            aria-label="Clear search"
            (click)="search = ''; searchInList.next($event)"
          >
            <i class="pi pi-times"></i>
          </button>
        }
      </div>

      <!-- Actions -->
      <div class="action-buttons">
        <!-- <button
          type="button"
          class="btn primary"
          (click)="createNew()"
        >
          <i class="pi pi-plus"></i>
          <span>Create New</span>
        </button> -->
      </div>

    </div>


    <!-- =====================================================
         COMPANY TABLE
    ====================================================== -->
    <div class="card table-card">

      <table class="user-table">

        <!-- Table Header -->
        <thead>
          <tr>
            <th>Company Name</th>
            <th>Email</th>
            <th>Status</th>
            <th class="action-column">Action</th>
          </tr>
        </thead>


        <!-- Table Body -->
        <tbody>

          <!-- Empty State -->
          @if (listOfClients.length === 0) {

            <tr>
              <td colspan="4" class="no-record">

                <div class="empty-state">

                  <div class="empty-state-icon">
                    <i class="pi pi-building"></i>
                  </div>

                  <h4>No Companies Found</h4>

                  <p>
                    There are no companies available to display.
                  </p>

                  @if (search) {
                    <button
                      type="button"
                      class="empty-clear-btn"
                      (click)="search = ''; searchInList.next($event)"
                    >
                      Clear Search
                    </button>
                  }

                </div>

              </td>
            </tr>

          }


          <!-- Company Rows -->
          @for (
            item of listOfClients;
            track item;
            let i = $index
          ) {

            <tr>

              <!-- Company -->
              <td>
                <div class="company-info">

                  <div class="company-avatar">
                    {{ item.company_name?.charAt(0)?.toUpperCase() }}
                  </div>

                  <div class="company-details">
                    <span class="company-name">
                      {{ item.company_name }}
                    </span>

                    <!-- <span class="company-label">
                      Company
                    </span> -->
                  </div>

                </div>
              </td>


              <!-- Email -->
              <td>
                <div class="email-info">
                  <i class="pi pi-envelope"></i>

                  <span>
                    {{ item.email_id }}
                  </span>
                </div>
              </td>


              <!-- Status -->
              <td>

                <span
                  class="status"
                  [ngClass]="
                    item.is_approved
                      ? 'active'
                      : 'inactive'
                  "
                >
                  <span class="status-dot"></span>

                  {{
                    item.is_approved
                      ? 'Active'
                      : 'De-Active'
                  }}
                </span>

              </td>


              <!-- Actions -->
              <td class="actions">

                <div class="action-group">

                  <!-- Activate / Deactivate -->
                  <button
                    type="button"
                    class="icon-btn success has-tooltip-left"
                    [attr.data-tooltip]="
                      item.is_approved
                        ? 'Deactivate company'
                        : 'Activate company'
                    "
                    [attr.aria-label]="
                      item.is_approved
                        ? 'Deactivate company'
                        : 'Activate company'
                    "
                    (click)="
                      changeClientStatus(
                        item,
                        item.is_approved
                          ? 'De-Active'
                          : 'Active'
                      )
                    "
                  >
                    <i class="pi pi-sync"></i>
                  </button>


                  <!-- Edit -->
                  <button
                    type="button"
                    class="icon-btn warning has-tooltip-left"
                    data-tooltip="Edit company"
                    aria-label="Edit company"
                    (click)="editClient(item)"
                  >
                    <i class="pi pi-pencil"></i>
                  </button>


                  <!-- Delete -->
                  <button
                    type="button"
                    class="icon-btn danger has-tooltip-left"
                    data-tooltip="Delete company"
                    aria-label="Delete company"
                    (click)="deleteClient(item)"
                  >
                    <i class="pi pi-trash"></i>
                  </button>

                </div>

              </td>

            </tr>

          }

        </tbody>

      </table>

    </div>


    <!-- =====================================================
         PAGINATION
    ====================================================== -->
    <div
      id="pagination"
      class="pagination-container"
    >

      <!-- Pagination Information -->
      <div class="pagination-info">

        @if (totalRowCount > 0) {

          <span>
            Showing

            <strong>
              {{ (page - 1) * RECORD_LIMIT + 1 }}
            </strong>

            to

            <strong>
              {{ showingCount }}
            </strong>

            of

            <strong>
              {{ totalRowCount }}
            </strong>

            companies
          </span>

        } @else {

          <span>
            Showing <strong>0</strong> companies
          </span>

        }

      </div>


      <!-- Pagination Controls -->
      <div class="pagination-controls">

        <pagination-controls
          [maxSize]="7"
          [responsive]="true"
          [autoHide]="false"
          [directionLinks]="true"
          previousLabel="&#x276E;"
          nextLabel="&#x276F;"
          (pageChange)="pageChanged($event)"
        >
        </pagination-controls>

      </div>

    </div>

  </div>
</section>